import gql from 'graphql-tag';
const SELECT_IT_ACTIVITY_FRAGMENT = gql `
  fragment SelectItActivityFragment on SelectItActivity {
    incorrectAttempt {
      id
      audioId
      audio {
        id
        src
        description
      }
    }
    rounds {
      hint {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      roundInstructions: instructions {
        id
        audioId
        audio {
          id
          src
          description
        }
      }
      roundImage: image {
        id
        imageId
        image {
          id
          src
        }
      }
      questionHtml {
        id
        elements
      }
      textHtml {
        id
        elements
      }
      answers {
        id
        startIndex
        endIndex
        correct
      }
    }
  }
`;
export default SELECT_IT_ACTIVITY_FRAGMENT;
